module.exports = __webpack_public_path__ + "img/3.d92ee880.jpg";